import * as types from "../actions/types";
/******************* 
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  brandBannerInfo:{},
  brandVehiclesMetaData:[],
  brandVehiclesList:[],
  filterPrice:{},
  totalRecord:'',
};

/******************* 
@purpose : Brand Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function brand(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /
    case types.SET_BRAND_BANNER_INFO:
    return Object.assign({}, ini_data, {
      brandBannerInfo: action.data,
    });
    case types.SET_BRAND_VEHICLE_META_DATA:
    return Object.assign({}, ini_data, {
      brandVehiclesMetaData: action.data,
    });
    case types.SET_BRAND_VEHICLE_LIST:
    return Object.assign({}, ini_data, {
        brandVehiclesList: [...ini_data.brandVehiclesList,...action.data],
    });
    case types.SET_BRAND_VEHICLE_LIST_CLEAR:
    return Object.assign({}, ini_data, {
      brandVehiclesList: [],
    });
    case types.SET_FILTER_PRICE_ACTION:
    return Object.assign({}, ini_data, {
      filterPrice: action.data,
    });
    case types.SET_BRAND_VEHICLE_TOTAL_RECORD:
    return Object.assign({}, ini_data, {
      totalRecord: action.data,
    });

    
    
    default:
      return ini_data;
  }
}
